'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _firebase = require('../libraries/firebase.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Redeem Gift - Vue Component
----------------------------*/

_vue2.default.component('redeem-gift', {
  data: function data() {
    return {
      giftCode: ''
    };
  },

  mounted: function mounted() {},
  methods: {
    submitGiftCode: function submitGiftCode() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var giftCodeDoc, giftCodeData;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _firebase.db.collection('giftCodes').doc(_this.giftCode).get();

              case 2:
                giftCodeDoc = _context.sent;


                // If the gift code exists then process.
                if (giftCodeDoc.exists) {
                  // Gift code data.
                  giftCodeData = giftCodeDoc.data();

                  console.log(giftCodeData);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {}
});